import { TextInlineEditor } from 'components/inline_edit/TextInlineEditor';
import { usePermissions } from 'contexts/PermissionsContext';
import { CorporationsTableCellProps } from 'pages/Settings/Corporations/CorporationsTable';
import { FullWidthWrapper } from 'pages/Settings/shared/styled';
import { updateCorporation } from 'utils/corporation';

export function CorporationNameCell({ rowData, onChange }: CorporationsTableCellProps) {
    const { canEditCorporationSettings } = usePermissions();
    const onUpdateCorporationName = async (updatedName: string | undefined) => {
        if (!updatedName) {
            throw new Error('Attempted to save corporation without a name');
        }
        try {
            onChange(
                await updateCorporation(rowData, {
                    Name: updatedName,
                })
            );
        } catch {
            return 'Unable to save name for corporation';
        }
        return undefined;
    };

    return (
        <FullWidthWrapper>
            <TextInlineEditor
                value={rowData.Name}
                onConfirm={onUpdateCorporationName}
                validate={(val) => {
                    if (!val?.trim()) {
                        return 'Corporation name is required';
                    }
                    if (val.length > 50) {
                        return 'Corporation name must be 50 characters or less';
                    }
                    return undefined;
                }}
                isDisabled={!canEditCorporationSettings}
            />
        </FullWidthWrapper>
    );
}
